import React, { useState } from "react";
import "./Login.css";
import { LoginCall } from "../../api/Auth";
import { useNavigate, useSearchParams } from 'react-router-dom';

const AdminLogin = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const [credentials, setCredentials] = useState({
        username: "",
        password: ""
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(
        searchParams.get('expired') === '1' ? "Your session has expired. Please log in again." : null
    );

    const handleChange = (e) => {
        setCredentials({ ...credentials, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        LoginCall(credentials)
            .then((response) => {
                const data = response?.data?.data;
                const token = data?.access_token;
                if (token) {
                    localStorage.setItem('token', token);
                    const user = data?.user || {};
                    const role = user.role || 'admin';
                    localStorage.setItem('user_role', role);
                    localStorage.setItem('user_info', JSON.stringify(user));
                    localStorage.removeItem('client_tv_id');
                    navigate('/dashboard');
                } else {
                    setError("Invalid response received from server.");
                }
            })
            .catch((err) => {
                console.error("Admin login failed:", err);
                setError(err.response?.data?.message || "Invalid administrator credentials. Please verify your login.");
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <div className="login-page-container">
            <div className="login-card">
                {/* Brand Header */}
                <div className="login-brand-header">
                    <div className="login-brand-icon icon-admin">
                        <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
                            <polygon points="12 2 2 7 12 12 22 7 12 2"></polygon>
                            <polyline points="2 17 12 22 22 17"></polyline>
                            <polyline points="2 12 12 17 22 12"></polyline>
                        </svg>
                    </div>
                    <h1>Nanba Command Center</h1>
                    <p>Enter administrator credentials to access platform operations</p>
                </div>

                {error && (
                    <div className="login-error-banner" style={{ marginBottom: "18px" }}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <circle cx="12" cy="12" r="10"></circle>
                            <line x1="12" y1="8" x2="12" y2="12"></line>
                            <line x1="12" y1="16" x2="12.01" y2="16"></line>
                        </svg>
                        <span>{error}</span>
                    </div>
                )}

                <form onSubmit={handleSubmit} className="login-form">
                    <div className="login-form-group">
                        <label>Admin Username</label>
                        <input
                            type="text"
                            name="username"
                            className="login-input"
                            value={credentials.username}
                            onChange={handleChange}
                            placeholder="Enter admin username"
                            autoComplete="username"
                            required
                        />
                    </div>

                    <div className="login-form-group">
                        <label>Password</label>
                        <input
                            type="password"
                            name="password"
                            className="login-input"
                            value={credentials.password}
                            onChange={handleChange}
                            placeholder="Enter password"
                            autoComplete="current-password"
                            required
                        />
                    </div>

                    <button
                        type="submit"
                        className="login-submit-btn btn-admin"
                        disabled={loading}
                    >
                        {loading ? "Verifying Administrator..." : "Sign In to Operations →"}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default AdminLogin;
